"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edisonPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var edisonPalette = {
  edison10: '#FCF2DF',
  edison30: '#FEE9C3',
  edison60: '#FFDB89',
  edison: '#FFC651',
  edisonDark: '#DE9809',
  edisonDarkest: '#9B6D0F'
};
exports.edisonPalette = edisonPalette;